import * as THREE from "three";
import { to3Ds_Left, to3Ds_Right, to3D_Front, to3D_Back, getBoxZ } from "../shape/Intersect";

/**
 * Get the 2D trim points based on the given mesh.
 * @param {THREE.Mesh} mesh - The mesh to calculate the trim points from.
 * @returns {THREE.Vector3[]} An array of trim points.
 */
export const GetTrim2D = (mesh) => {
  var [min_x0, max_x0, min_y0, max_y0] = getBoxZ(mesh, 50); // TODO: modify getBoxZ to getBoxY, because coordinate is different
  var [min_xn, max_xn, min_yn, max_yn] = getBoxZ(mesh, 0);
  const mid_y1 = max_y0 - (max_yn - min_y0) * 1/5;
  const mid_y2 = max_y0 - (max_yn - min_y0) * 2/5;
  const mid_y3 = max_y0 - (max_yn - min_y0) * 3/5;
  const mid_y4 = max_y0 - (max_yn - min_y0) * 4/5;

  var pt1 = new THREE.Vector3(0, 30, max_y0+5);
  var pt2 = new THREE.Vector3(0, 30, max_y0-5);
  var pt3 = new THREE.Vector3(0, 40, mid_y1);
  var pt4 = new THREE.Vector3(0, 50, mid_y2);
  var pt5 = new THREE.Vector3(0, 40, mid_y3);
  var pt6 = new THREE.Vector3(0, 15, mid_y4);
  var pt7 = new THREE.Vector3(0, 0, min_yn+5);
  var pt8 = new THREE.Vector3(0, 0, min_yn-5);

  return [pt1, pt2, pt3, pt4, pt5, pt6, pt7, pt8];
}


// トリミング用3D点群を生成
// mesh: 投影するオブジェクト
// vpt2D: [Vector2]
//   点0と点Nは端点計算に用いる
//   点1〜点N-1は、オブジェクト上に投影する
// return: [Vector3]  点数はvpt2D.length * 2 + 2

/**
 * Project 2D trim curve to 3D
 * @param {THREE.Mesh} mesh 
 * @param {THREE.Vector3[]} vpt2D
 * @returns {THREE.Vector3[]} vpt3D, 3D projection of vpt2D
 */
export function GetTrim3D(mesh, vpt2D){
  const vptR = to3Ds_Right(mesh, vpt2D, true);
  const vptL = to3Ds_Left(mesh, vpt2D, true);

  if(vptR.length != vptL.length)
    console.error("vptR and vptL have different length");
  if(vptR.length != vpt2D.length - 2)
    console.error("2D data is out of rule");

  var pt0 = new THREE.Vector2(0, vpt2D[0].z); // TODO: take care of coordinate, not opengl coordinate
  var ptN = new THREE.Vector2(0, vpt2D[vpt2D.length-1].z);
  const vpt0 = to3D_Front(mesh, pt0);
  const vptN = to3D_Back(mesh, ptN);

  var vpt3D = [];
  //vpt3D.push(vpt0); // TODO: remove temporary, little bit strange position
  for(var i=0; i<vptR.length; i++){
    vpt3D.push(vptR[i]);
  }
  //vpt3D.push(vptN); // TODO: remove temporary, little bit strange position
  for(var i=vptL.length-1; i>=0; i--){
    vpt3D.push(vptL[i]);
  }

  return vpt3D;
}

